export default {
  ITEM: 'ITEM',
  BREAKDOWN: 'BREAKDOWN',
  COST: 'COST',
  LOCATION: 'LOCATION',
  ARTWORK: 'ARTWORK',
  IMAGE: 'IMAGE',
  SEARCHTAB: 'SEARCHTAB',
};
